<script setup>
  import { useField } from "vee-validate";
  import { toRef } from "vue";
  import { FormLabel } from "@/base-components/Form";
  import { useI18n } from "vue-i18n";
  import Lucide from "@/base-components/Lucide";

  const { t: $t } = useI18n();
  const props = defineProps({
    name: String,
    placeholder: String,
    value: String | Number | Boolean,
    modelValue: String | Number | Boolean,
    type: String,
    dir: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    hasLabel: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    deleteButton: {
      type: Boolean,
      default: false,
    },
  });

  const name = toRef(props, "name");
  const { value, errorMessage } = useField(name, undefined, {
    syncVModel: true,
  });
  const emit = defineEmits(["deleteButtonClick"]);
  const onInput = (e) => {
    emit("update:modelValue", e.target.value);
  };
</script>

<template>
  <div>
    <FormLabel htmlFor="input-wizard-3" v-if="hasLabel">
      {{ label }}
    </FormLabel>
    <div class="h-10 relative">
      <div
        v-if="deleteButton"
        class="button-label"
        @click="emit('deleteButtonClick')"
      >
        <Lucide icon="X" class="w-5 h-5" />
      </div>

      <input
        :value="modelValue"
        @input="onInput"
        :type="type || 'text'"
        :disabled="disabled"
        :dir="dir"
        :placeholder="placeholder || ''"
        class="disabled:bg-slate-100 disabled:cursor-not-allowed dark:disabled:bg-darkmode-800/50 dark:disabled:border-transparent [&[readonly]]:bg-slate-100 [&[readonly]]:cursor-not-allowed [&[readonly]]:dark:bg-darkmode-800/50 [&[readonly]]:dark:border-transparent transition duration-200 ease-in-out w-full text-sm border-slate-200 shadow-sm rounded-md placeholder:text-slate-400/90 focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus:border-primary focus:border-opacity-40 dark:bg-darkmode-800 dark:border-transparent dark:focus:ring-slate-700 dark:focus:ring-opacity-50 dark:placeholder:text-slate-500/80"
        :class="{
          'border-red-600 shadow-red-600 focus:ring-red-500 focus:ring-opacity-10':
            !!errorMessage,
        }"
      />
      <span v-if="errorMessage" class="text-red-600 text-[10px] font-bold">
        * {{ $t(`message.${errorMessage}`) }}
      </span>
    </div>
  </div>
</template>
<style scoped>
  .button-label {
    width: 20px;
    height: 20px;
    position: absolute;
    top: -9px;
    left: -8px;
    cursor: pointer;
    color: red;
    background: white;
    border: 1px solid red;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
